import React, {useState, useEffect} from 'react'
import Loading from '../general/Loading';
import '../css/components/ViewUsers.css';

const ViewUsers = ({userData, setResponse}) => {
    const [users, setUsers] = useState([]);
        const [loading, setLoading] = useState(false);
        const [searchQuery, setSearchQuery] = useState('');
        const [showVerify, setShowVerify] = useState(false);
        const [showBlock, setShowBlock] = useState(false);
        const [selectedUser, setSelectedUser] = useState('');
  const [visibleCount, setVisibleCount] = useState(30);

  useEffect(() => {
    setVisibleCount(30);
  }, [searchQuery]);


    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.siddhabhairabistore.com/get-users');

                if (response.ok) {
                    const data = await response.json();
 const filteredUsers = data.filter(user => user.id != userData.id).sort((a, b) => b.id - a.id);


                    setUsers(filteredUsers);
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        };

        fetchUsers();
    }, []);


const filterUsers = users.filter(myItem =>
  (myItem.user_name?.toLowerCase().includes(searchQuery.toLowerCase()) || 
   myItem.mobile?.toLowerCase().includes(searchQuery.toLowerCase()))
);

useEffect(() => {
  const interval = setInterval(() => {
    setVisibleCount((prev) => {
      if (prev >= filterUsers.length) {
        clearInterval(interval);
        return prev;
      }
      return prev + 30;
    });
  }, 2500);

  return () => clearInterval(interval);
}, [filterUsers]);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const handleShowVerify = (product) => {
    setSelectedUser(product);
    setShowVerify(true);
  }

    const handleShowBlock = (product) => {
    setSelectedUser(product);
    setShowBlock(true);
  }



  const handleVerifyYes = async () => {
  try {
    const response = await fetch(`https://api.siddhabhairabistore.com/verify-user/${selectedUser.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.ok) {
const updatedUsers = users.map(user =>
  user.id === selectedUser.id ? { ...user, active: 1 } : user
);
      setUsers(updatedUsers);
        setResponse({ message: 'Account Activation successful!', status: 'success' });
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      setShowVerify(false);
    } else {
                setResponse({ message: 'Unable to Activate Account.', status: 'error' });
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      console.error('Failed to update user');
    }
  } catch (error) {
    console.error('Error updating user:', error);
  }
};



const handleBlockYes = async () => {
  try {
    // Determine the new block status based on current value
    const newBlockStatus = selectedUser.block_user === 'Unblocked' ? 'Blocked' : 'Unblocked';

    const response = await fetch(`https://api.siddhabhairabistore.com/block-user/${selectedUser.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ block_status: newBlockStatus })
    });

    if (response.ok) {
      // Update local state to reflect new block status
      const updatedUsers = users.map(user =>
        user.id === selectedUser.id ? { ...user, block_user: newBlockStatus === 'Blocked' ? 'Blocked' : 'Unblocked' } : user
      );
      setUsers(updatedUsers);

      setResponse({ message: `User ${newBlockStatus === 'Blocked' ? 'Blocked' : 'Unblocked'} successfully!`, status: 'success' });
      setTimeout(() => setResponse(''), 2000);
      setShowBlock(false);
    } else {
      setResponse({ message: 'Unable to update user block status.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
      console.error('Failed to update user block status');
    }
  } catch (error) {
    console.error('Error updating user block status:', error);
  }
};


const totalUsers = users.length;

const verifiedUsers = users.filter(
  user => user.active != null
).length;

const nonVerifiedUsers = users.filter(
  user => user.active == null
).length;

const currentMonth = new Date().getMonth();
const currentYear = new Date().getFullYear();

const usersThisMonth = users.filter(user => {
  const createdDate = new Date(user.created_on);

  return (
    createdDate.getMonth() === currentMonth &&
    createdDate.getFullYear() === currentYear
  );
}).length;

    return (
    <>
        <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>View Users</p>
          {/* <button className='edit-btn' onClick={() => navigate('/add-party')}>Add Party</button> */}
        </div>

        <div className='row my-3'>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='bg-dark rounded-3 p-3 shadow-sm'>
      <p className='para-text text-light fw-semibold mb-1'>Total Users</p>
      <h3 className='fw-bold text-light'>{totalUsers}</h3>
    </div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='bg-info rounded-3 p-3 shadow-sm'>
      <p className='para-text text-muted fw-semibold mb-1'>Users This Month</p>
      <h3 className='fw-bold text-light'>{usersThisMonth}</h3>
    </div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='bg-success rounded-3 p-3 shadow-sm'>
      <p className='para-text text-light fw-semibold mb-1'>Verified Users</p>
      <h3 className='fw-bold text-light'>{verifiedUsers}</h3>
    </div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='bg-warning rounded-3 p-3 shadow-sm'>
      <p className='para-text text-muted fw-semibold mb-1'>Non Verified Users</p>
      <h3 className='fw-bold text-light'>{nonVerifiedUsers}</h3>
    </div>
  </div>

</div>

                    <div className='d-flex bg-white rounded-2 py-2 my-3'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search By Name, Mobile"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

<div className='row'>
              {filterUsers.slice(0, visibleCount).map(product => (
                <div className='col-lg-4 col-md-6 col-12 my-2'>
                    <div className='user-area'>

<div className='text-center'>
    <i class="fa-solid fa-shop fs-3" style={{color: 'pink'}}></i>
<p className='fw-semibold mt-2'>{product.user_name}</p></div>

<p className='category-text my-0'>User Details:</p>
<p className='para-text text-muted'>Shop Name: {product.shop_name || 'NA'}<br />Mobile: {product.mobile}<br />Email: {product.email || 'NA'}<br />
Address: {product.address} {product.city} {product.state} {product.pincode}</p>

{product.active == null ? 
<span className='text-blue para-text float-end fw-semibold cursor-pointer' onClick={() => handleShowVerify(product)}>Verify Now</span>
: <span className='para-text float-end fw-semibold text-success'>Verified</span>
}
<p className='category-text my-0'>Other:</p>
<p className='para-text text-muted'>Account Status: {product.active == null ? 'Inactive': 'Active'}<br />Dealer Type: {product.dealer_type || 'NA'}<br />GSTIN No: {product.gst_no || 'NA'}<br />Account Created On: {formatDate(product.created_on)}</p>

<p className='text-danger para-text text-end fw-semibold cursor-pointer' onClick={() => handleShowBlock(product)}><i class="fa-solid fa-ban"></i> {product.block_user == 'Unblocked' ? 'Block User' : 'Unblock User'}</p>


</div>
</div>

              ))}
</div>

        </div>
        </section>
      
                  {loading && <Loading setLoading={setLoading} />}

{showVerify && (
    <>
      <section className='bill-area'>
    <div className='bill-inner col-lg-4 col-10 mx-auto'>

<p className='page-title'>Verify Account!</p>

<p>Have you verified the Account details for "{selectedUser.user_name}"?</p>

<button className='edit-btn' onClick={handleVerifyYes}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowVerify(false)}>No</button>

</div>
</section>
    </>
)}


{showBlock && (
    <>
      <section className='bill-area'>
    <div className='bill-inner col-lg-4 col-10 mx-auto'>

<p className='page-title'>{selectedUser.block_user == 'Unblocked' ? 'Block User' : 'Unblock User'} Account!</p>

<p>Confirm do you want to {selectedUser.block_user == 'Unblocked' ? 'Block' : 'Unblock'} this Account of {selectedUser.user_name}?</p>

<button className='edit-btn' onClick={handleBlockYes}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowBlock(false)}>No</button>

</div>
</section>
    </>
)}
    </>
  )
}

export default ViewUsers
